/**
 * Where the tool is mounted for this visitor, and how to link within it.
 *
 * Anonymous visitors stay on `/design-tokenomics`; once a project exists the project-id middleware
 * scopes every route to `/project/:projectId/design-tokenomics`, and section links have to follow
 * or each one costs a redirect.
 *
 * Not to be confused with `getProjectPath` (core), which always prefixes `/project/:id` and falls
 * back to `'default'`, so it cannot express the anonymous case.
 */
export function useDesignRoot() {
  const route = useRoute()

  const root = computed(() =>
    route.params.projectId
      ? `/project/${route.params.projectId}/design-tokenomics`
      : '/design-tokenomics',
  )

  /** Absolute path for a section page, or `undefined` for a page that is not built yet. */
  function sectionPath(path?: string) {
    return path ? `${root.value}${path}` : undefined
  }

  return { root, sectionPath }
}
